import { render, staticRenderFns } from "./blok-grid.vue?vue&type=template&id=17c1d5e4&scoped=true"
import script from "./blok-grid.vue?vue&type=script&lang=js"
export * from "./blok-grid.vue?vue&type=script&lang=js"
import style0 from "./blok-grid.vue?vue&type=style&index=0&id=17c1d5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1d5e4",
  null
  
)

export default component.exports